
import { parseAsString, useQueryState } from "nuqs";
import { useMemo } from "react";

const useIsFromBingoCheck = () => {
  const [fromPage] = useQueryState(
    "from",
    parseAsString.withOptions({ clearOnDefault: true }).withDefault("")
  );

  const isFromBingo = useMemo(() => fromPage === "bingo", [fromPage]);
  return { isFromBingo };
};

export default useIsFromBingoCheck;

